import { useState } from "react";
import { Plus } from "lucide-react";

export const FAQS = [
  {
    q: "Posso iniziare davvero gratis?",
    a: "Sì. Il piano Free non scade e non chiede la carta di credito: hai i tre moduli operativi con dei limiti — sedi, clienti e report produzione, 1 magazzino con 50 utensili e 50 attacchi base, 4 macchine, 2 componenti, 4 ordini cliente e 2 utenti. Acquisti, Qualità, Preventivazione e Controllo di gestione restano visibili ma bloccati.",
  },
  {
    q: "A cosa serve il piano Easy Tool da 35 €?",
    a: "È il piano di chi vuole solo il magazzino utensili in ordine: modulo Logistica generale e utensili senza limiti (catalogo utensili e attacchi base, magazzini e posizioni, inventario, movimenti, scorte minime, consumi, semilavorati e attrezzature di staffaggio) con 4 utenti. Acquisti, Produzione, Qualità, Preventivazione e Controllo di gestione non sono inclusi.",
  },
  {
    q: "Il modulo Acquisti e fornitori in quali piani è incluso?",
    a: "Nei piani Standard e Premium. Comprende l'anagrafica fornitori con listini importabili da Excel, condizioni di pagamento, lead time e puntualità calcolata dagli arrivi, le proposte di riordino su utensili, attacchi base, materie prime, ricambi e articoli d'acquisto, gli ordini ODA numerati con IVA, stampa e invio email, e l'arrivo merce parziale o a saldo che carica la giacenza nel magazzino e scrive il movimento. Con Free e Easy Tool la voce resta visibile nel menu ma bloccata.",
  },
  {
    q: "Quanti utenti posso invitare in officina?",
    a: "Free 2 utenti, Easy Tool 4, Standard 8 con ruoli e permessi per reparto, Premium senza limiti.",
  },
  {
    q: "Cosa cambia tra Standard e Premium?",
    a: "Standard toglie tutti i limiti su Logistica generale e utensili e Produzione (utensili, macchine, componenti e ordini illimitati), include sedi, clienti e report produzione e apre il modulo Acquisti e fornitori. Premium aggiunge il Controllo di gestione con margini di commessa, consuntivi di materiale e utensili, report clienti e alert direzionale, il modulo Qualità con piani di controllo e non conformità, il modulo Preventivazione con costi, margini e offerte in PDF, gli utenti illimitati, l'assistenza con priorità, il corso di 2 giorni gratuito e 3 ticket di assistenza gratuiti.",
  },
  {
    q: "Il modulo Qualità è incluso nei piani Free, Easy Tool e Standard?",
    a: "No: piani di controllo, quote misurate e non conformità sono inclusi nel piano Premium. Se ti serve per un audit ISO 9001 o IATF, Premium è il piano giusto.",
  },
  {
    q: "Che cos'è il modulo Preventivazione e in quale piano si trova?",
    a: "È il modulo che trasforma un disegno in un prezzo e fa parte del piano Premium (con Free, Easy Tool e Standard la voce resta visibile nel menu ma bloccata). Calcola i tempi dalle geometrie e dai parametri di taglio, applica la tariffa oraria di ogni macchina e ti mostra costo industriale, margine e prezzo proposto mentre scrivi.",
  },
  {
    q: "Come fa il preventivo a calcolare tempi e costi?",
    a: "Hai due strade. Il preventivo rapido parte dalle geometrie e dai parametri di taglio (fori, spianature, tornitura, filettature) e calcola giri, avanzamento, tempo di taglio e tempi accessori. Il preventivo analitico importa le fasi del ciclo del componente: tu scrivi attrezzaggio e tempo ciclo, il resto si valorizza con le tariffe delle macchine. In più aggiungi fasi esterne come rettifica e trattamenti termici, con minimo di fatturazione e giorni del fornitore che allungano la consegna.",
  },
  {
    q: "Il cliente vede i miei costi nell'offerta?",
    a: "Mai. Il PDF per il cliente mostra solo quantità, prezzi, consegna, condizioni e note, con il tuo logo. Costi, tariffe, margini e nomi dei fornitori restano nella stampa interna, che vede soltanto chi ha il permesso di vedere i costi. Il preventivo approvato si congela e ogni modifica genera una nuova revisione tracciata.",
  },
  {
    q: "Posso sapere se un preventivo era giusto?",
    a: "Sì. Dal preventivo accettato generi la commessa con le fasi e i tempi preventivati; man mano che l'officina timbra le lavorazioni, il preventivo mostra il confronto fra ore e costi previsti e reali, con pezzi buoni, scarti e margine ricalcolato sul prezzo di vendita.",
  },
  {
    q: "Come funziona il corso di 2 giorni del piano Premium?",
    a: "È incluso e gratuito: due giornate di formazione sui moduli che usi davvero, da concordare in remoto oppure in officina, così la squadra parte senza tentativi a vuoto.",
  },
  {
    q: "E i 3 ticket di assistenza gratuiti?",
    a: "Sono tre richieste di assistenza dedicata senza costi aggiuntivi, gestite con priorità sulla coda: configurazioni, import complessi o dubbi operativi.",
  },
  {
    q: "Posso cambiare o disdire il piano quando voglio?",
    a: "Sì, il cambio è immediato e senza vincoli annuali. Se torni a un piano più piccolo i tuoi dati restano, si applicano soltanto i limiti del nuovo piano.",
  },
  {
    q: "I miei dati restano miei?",
    a: "Sempre. Catalogo, giacenze, componenti e controlli sono esportabili in Excel e PDF in qualsiasi momento, senza chiedere niente a nessuno.",
  },
  {
    q: "Quanto tempo serve per partire con il catalogo che ho in Excel?",
    a: "L'import Excel guidato controlla il file riga per riga e segnala gli errori prima di salvare: in genere si carica il catalogo e si è operativi nello stesso giorno.",
  },
];

export function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="landing-faq" id="faq" data-testid="landing-faq">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">DOMANDE <i /> FREQUENTI</p>
        <h2>Le risposte prima di decidere</h2>
        <p className="landing-desc">Quello che chiedono le officine quando valutano se portare utensili, acquisti, produzione, qualità e preventivi dentro un unico posto.</p>
      </div>

      <div className="landing-faq-list landing-reveal">
        {FAQS.map((item, index) => (
          <div className={`landing-faq-item ${open === index ? "is-open" : ""}`} key={item.q} data-testid={`faq-item-${index}`}>
            <button
              type="button"
              className="landing-faq-q"
              aria-expanded={open === index}
              onClick={() => setOpen(open === index ? -1 : index)}
              data-testid={`faq-question-${index}`}
            >
              <span>{item.q}</span><Plus size={16} />
            </button>
            {open === index && <p className="landing-faq-a" data-testid={`faq-answer-${index}`}>{item.a}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
